import { useCurrentUserContext, useDocumentFormContext } from '@cs-cms/state-management';
import React from 'react';
import CpsLoader from '../common/CpsLoader';
import { DocumentFormContent } from './DocumentFormContent';

export const CpsDocumentForm: React.FC = () => {
  const { editedDocument } = useDocumentFormContext();
  const { selectedIndex } = useCurrentUserContext();

  if (!editedDocument) {
    return null;
  }

  if (selectedIndex?.id === undefined) {
    return <CpsLoader />;
  }

  return <DocumentFormContent indexId={selectedIndex.id} />;
};
